export default __webpack_public_path__ + "static/media/showroom43.50d19f62.webp";